import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { use } from 'react';
import { useHistory } from "react-router-dom";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const initialState = JSON.parse(localStorage.getItem('authState')) || {
    isAuthenticated: false,
    clubId: null,
    userId: null,
    isSuperAdmin:false,
    superCompanyId:null,
    clubName:null,
    branchName:null,
    permissions: [],
    token:null,
    roleName:null,
    branchId:null,
    username:null
  };

  const [authState, setAuthState] = useState(initialState);
  const history = useHistory();

  const login = useCallback((clubId,branchId,userId,isSuperAdmin,superCompanyId,clubName, permissions,token,roleName,branchName,username) => {
    setAuthState((prevState) => {
      const newState = {
        ...prevState,
        isAuthenticated: true,
        clubId: clubId,
        userId: userId,
        isSuperAdmin:isSuperAdmin,
        superCompanyId:superCompanyId,
        clubName:clubName,
        branchName:branchName,
        permissions: permissions,
        token:token,
        roleName:roleName,
        branchId:branchId,
        username:username
      };
      localStorage.setItem('authState', JSON.stringify(newState));
      return newState;
    });
  }, []);

  const clearAuthState = useCallback(() => {
    setAuthState({
      isAuthenticated: false,
      clubId: null,
      userId: null,
      isSuperAdmin:false,
      superCompanyId:null,
      clubName:null,
      branchName:null,
      permissions: [],
      token:null,
      roleName:null,
      branchId:null,
      username:null
    });
    

    // Clear local storage
    localStorage.removeItem('authState');
  }, []);

  const logout = useCallback(() => {
    clearAuthState();
    history.push("/"); // Redirect to the login page after logout When Using Older Navbar
    window.location.reload();
  }, [clearAuthState, history]);

  const ClearToken = useCallback(() => {
    clearAuthState();    
  }, [clearAuthState, history]);

  useEffect(() => {
    localStorage.setItem('authState', JSON.stringify(authState));
  }, [authState]);

  const value = {
    ...authState,
    login,
    logout,
    ClearToken,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
